import React, { useEffect, useState, } from 'react'
import { message, Icon, Dropdown, Avatar, List, Tooltip, Tag, Button, Popover } from 'antd';
import * as services from '@/models/orders/services';
import styles from './style.module.less';

export default function TagFlag(props) {
  const { itemId, flag = 0, change } = props;
  const [tagFlag, setTagFlag] = useState(0)
  const [visible, setVisible] = useState(false)

  const flagList = [
    { type: 1 },
    { type: 2 },
    { type: 3 },
    { type: 4 },
    { type: 5 },
    { type: 6 },
  ]
  const clickItem = (type) => {
    if (type == tagFlag) return false;
    services.setTaskTag({ id: itemId, tagFlag: type })
      .then((result) => {
        setVisible(false)
        typeof change === 'function' && change()
      })
      .catch((err) => {
        message.error(err.message || '提交失败');
      })
      .finally(() => {
      });
  }
  const setTag = () => {
    let tag_flag = flag || 0
    if (tag_flag < 1 || tag_flag > 6) {
      tag_flag = 1
    }
    setTagFlag(tag_flag)
  }
  useEffect(() => {
    setTag()
  }, [flag])
  useEffect(() => {
    setTag()
    return () => {
    }
  }, [])

  const popoverContent = (
    <List
      size="small"
      dataSource={flagList}
      renderItem={item => (
        <List.Item key={item.type} style={{ padding: '5px 0' }} onClick={() => {
          clickItem(item.type)
        }}>
          <List.Item.Meta
            avatar={<Avatar size={20} src={`/images/flag${item.type}.png`} />}
          />
          <div>
            {item.type == tagFlag && <Icon type="check" />}
          </div>
        </List.Item>
      )}
    >

    </List>
  );

  return (
    <>
      <Popover
        content={popoverContent}
        // title="旗帜"
        trigger="click"
        visible={visible}
        placement="rightTop"
        onVisibleChange={(visible) => { setVisible(visible) }}
      >
        <img src={`/images/flag${tagFlag}.png`} className={styles.flag} onClick={e => e.stopPropagation()} />
      </Popover>
    </>
  );
}
